import { library, dom } from '@fortawesome/fontawesome-svg-core';
import * as farIcons from '@fortawesome/pro-regular-svg-icons';

// app/initializers/fontawesome.js
function initialize() {
  // Aggiunge solo le icone valide (quelle che iniziano con "fa")
  const icons = Object.keys(farIcons).filter(key => key.startsWith('fa')).map(key => farIcons[key]).filter(Boolean);
  library.add(...icons);
  dom.watch();

  // FontAwesome icons loaded
}
var fontawesome = {
  initialize
};

export { fontawesome as default, initialize };
//# sourceMappingURL=fontawesome.js.map
